import React, { useEffect, useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import MultiRangeSlider from "../../multirangeslider/MultiRangeSlider";
import PortfolioField from "./portfolio-field";
import OwnerOccupiedField from "./owner-occupied-field";
import UpgradeOverlay from "../../../common/UpgradeOverlay";
import { upgradeMessage, userIsRestrictedFromPortfolio } from "../../../../hooks/useCommercialAccess";
import { useSelector } from "react-redux";

export default function OwnerMoreFilters({
  register,
  watch,
  setValue,
  filterData,
}) {
  const memData = useSelector((state) => state.fetchSiteSettings?.memData);
  const isPortfolioRestricted = userIsRestrictedFromPortfolio(memData);

  const [portfolioRange, setPortfolioRange] = useState([0, 100000000]);

  useEffect(() => {
    register("portfolio_assessed_value");
  }, [register]);

  useEffect(() => {
    const value = filterData?.portfolio_assessed_value;
    if (value && Array.isArray(value) && value.length === 2) {
      const min = Number(value[0]);
      const max = Number(value[1]);
      setPortfolioRange([min, max]); // Update slider state
      setValue("portfolio_assessed_value", [min, max]); // Update form state
    }
  }, [filterData?.portfolio_assessed_value, setValue]);
  const handleOwnerType = (type) => {
    setValue("owner_type", type);
  };

  return (
    <>
      <div className="col">
        <div className="form_blk">
          <div className="info_lbl_lbl">
            <h6>Owner</h6>
          </div>
          <input
            type="text"
            className="input"
            name="owner_name"
            placeholder="Person or Company name"
            {...register("owner_name")}
          />
        </div>
      </div>
      <div className="col half_flex_form">
        <PortfolioField
          register={register}
          fieldNamePrefix="owner"
          watch={watch}
          setValue={setValue}
          filterData={filterData}
        />
      </div>
      <div className="col">
        <div className="form_blk">
          <div className="info_lbl_lbl">
            <h6>Owner type</h6>
          </div>
          <div className="boolean_flex">
            <div className="lbl_btn">
              <input
                type="radio"
                name="owner_type"
                value="Company"
                id="Company"
                className="hidden"
                defaultChecked={filterData?.owner_type === "Company"}
                {...register("owner_type")}
              />
              <label
                for="Company"
                className={`site_btn blank yellow_blank main_color ${
                  filterData?.owner_type === "Company" ? "active" : ""
                }`}
                onClick={() => handleOwnerType("Company")}
              >
                <span>Company</span>
              </label>
            </div>
            <div className="lbl_btn">
              <input
                type="radio"
                name="owner_type"
                value="Individual"
                id="Person"
                className="hidden"
                defaultChecked={filterData?.owner_type === "Individual"}
                {...register("owner_type")}
              />
              <label
                for="Person"
                className={`site_btn blank yellow_blank main_color ${
                  filterData?.owner_type === "Individual" ? "active" : ""
                }`}
                onClick={() => handleOwnerType("Individual")}
              >
                <span>Individual</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="col cstm_flex_owner">
        <div className="form_blk">
          <div className="info_lbl_lbl">
            <h6>Owner Occupied</h6>
          </div>
          <OwnerOccupiedField
            register={register}
            filterData={filterData}
            setValue={setValue}
            watch={watch}
            fieldNamePrefix="owner"
          />
        </div>
        <div className="form_blk top_less_mrgn">
          <div className="lbl_btn">
            <input
              type="checkbox"
              name="previously_viewed"
              value="yes"
              id="previously_viewed"
              {...register("previously_viewed")}
              defaultValue={filterData?.previously_viewed}
            />
            <label className="previousLabel" for="previously_viewed">
              <span> Display previously viewed properties</span>
              <ReactTooltip
                id="previously-viewed-properties"
                place="bottom"
                content="By choosing this option you will be able to view all properties you have already viewed property owner contact information for"
              />
              <div
                className="info_span"
                data-tooltip-id="previously-viewed-properties"
              >
                <span className="ic_on">
                  <img src="/images/info-circle.svg" alt="" />
                </span>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div className="col"></div>

      <div className="col half_flex_form">
        <div
          className="form_blk range_slide"
          style={isPortfolioRestricted ? { position: "relative" } : undefined}
        >
          <div className="info_lbl_lbl">
            <h6>Portfolio assessed value</h6>
          </div>

          <MultiRangeSlider
            name="portfolio_assessed_value"
            minValue={portfolioRange[0]}
            maxValue={portfolioRange[1]}
            min={0}
            max={100000000}
            onChange={({ min, max }) => {
              // Inert while restricted: a locked portfolio must not be able to
              // push an assessed-value bound into the search.
              if (isPortfolioRestricted) return;
              setPortfolioRange([min, max]);
              setValue("portfolio_assessed_value", [min, max]);
            }}
          />

          {isPortfolioRestricted && (
            <UpgradeOverlay
              title="Investor Portfolio"
              message={upgradeMessage(memData, "for access", "Investor Portfolio is not included on your plan.")}
              compact
              testId="portfolio-upgrade-overlay"
            />
          )}
        </div>
        <div className="br"></div>
        <div className="form_blk mt-10">
          <div className="info_lbl_lbl">
            <h6>Reported owner</h6>
            <ReactTooltip
              id="reported-owner"
              place="bottom"
              content="Current owner of the property"
            />
            <div className="info_span" data-tooltip-id="reported-owner">
              <span className="ic_on">
                <img src="/images/info-circle.svg" alt="" />
              </span>
            </div>
          </div>
          <input
            type="text"
            className="input"
            name="reported_owner"
            placeholder="Reported owner"
            {...register("reported_owner")}
            defaultValue={filterData?.reported_owner}
          />
        </div>
        <div className="br"></div>
        <div className="form_blk">
          <div className="info_lbl_lbl">
            <h6>Reported owner mailing address</h6>
          </div>
          <input
            type="text"
            className="input"
            name="reported_owner_address"
            placeholder="Mailing address"
            {...register("reported_owner_address")}
            defaultValue={filterData?.reported_owner_address}
          />
        </div>
      </div>
    </>
  );
}
